const baseStyle = {};
const defaultProps = {
    size: 'md'
};
const sizes = {
    xs: {
        height: 16,
        width: 16
    },
    sm: {
        height: 20,
        width: 20
    },
    md: {
        height: 24,
        width: 24
    },
    lg: {
        height: 28,
        width: 28
    },
    /** the xl size is introduced for the xxl-tabs and xl-avatars; should not be listed. */
    xl: {
        height: 32,
        width: 32
    },
    /** the xxl size is introduced for the xxl-avatars; should not be listed. */
    xxl: {
        height: 40,
        width: 40
    }
};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
